export default __webpack_public_path__ + "static/media/Rene-avatar.11095375.jpg";